import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import * as zxcvbn from 'zxcvbn';
import {
  PASSWORD_STRENGTH_KEY,
  PASSWORD_STRENGTH_SCORE,
} from '../../../constants/constants';

export function passwordStrengthValidator(returnScore = false): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { score } = zxcvbn(control.value);

    const result = { [PASSWORD_STRENGTH_KEY]: score };

    if (
      returnScore ||
      result[PASSWORD_STRENGTH_KEY] < PASSWORD_STRENGTH_SCORE.WARNING
    ) {
      return result;
    }

    return null;
  };
}
